import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { proceduresConfigurationServices } from '@/api/resources/configuration/samples/procedures/ProceduresConfigurationServices'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export const columnsDefProceduresGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.procedureCode'),
            field: 'code',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        },
        // TODO Pending to implement
        // {
        //     type: AgGridColumnType.TEXT,
        //     headerName: i18n.t('configuration.grid.specimenCode').toString(),
        //     field: 'codeSpecimen',
        //     width: 150,
        //     minWidth: 80,
        //     suppressSizeToFit: true
        // },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            field: 'description',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        // TODO Pending to implement
        // {
        //     type: AgGridColumnType.CHECK_ICON,
        //     headerName: i18n.tc('configuration.grid.ownCode'),
        //     field: 'ownCode',
        //     minWidth: 150,
        //     suppressSizeToFit: true
        // },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 150,
            suppressSizeToFit: true
        }
    ]

// TODO Pending to add ownCode, codeSpecimen
export interface IContentProceduresGrid {
    id?: number
    code: string
    description: string
    active: boolean
}
export const initialProceduresModalState =
    (): IContentProceduresGrid => ({
        id: undefined,
        code: '',
        description: '',
        active: false
    })

export type IProceduresGridState = CrudModelBase<IContentProceduresGrid>
export const initialProceduresGridState =
    (): IProceduresGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.samples.procedures',
        columnsDef: columnsDefProceduresGrid(),
        datasource: new PaginatorDatasource(proceduresConfigurationServices)
    })
